import { render, staticRenderFns } from "./UiMarketInvoices.vue?vue&type=template&id=07529c70&"
import script from "./UiMarketInvoices.vue?vue&type=script&lang=js&"
export * from "./UiMarketInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports